import React from "react";
import { HeaderProps, Modal } from "semantic-ui-react";

interface IProps {
  open: boolean;
  size?: "mini" | "tiny" | "small" | "large" | "fullscreen";
  cancelCallback: () => undefined | void;
  header: any; // prev HeaderProps
  content: React.ReactNode;
  actions?: React.ReactNode;
  closeOnDimmerClick?: boolean;
  closeOnEscape?: boolean;
}

const ConfirmModal = ({
  size,
  open,
  cancelCallback,
  header,
  content,
  actions,
  closeOnDimmerClick = false,
  closeOnEscape = false,
}: IProps) => {
  return (
    <Modal
      open={open}
      onClose={cancelCallback}
      size={size}
      closeOnDimmerClick={closeOnDimmerClick}
      closeOnEscape={closeOnEscape}
    >
      {header}
      {content && <Modal.Content>{content}</Modal.Content>}
      {actions && <Modal.Actions>{actions}</Modal.Actions>}
    </Modal>
  );
};

export default ConfirmModal;
